import merge from 'deepmerge';
import { Modal, Form, IFormContext, IEditorField, arraySearch, IFieldDefns } from 'rewire-ui';
import { IValidationRule } from '../DataTypes';
import ValidationRuleEditorModel from './ValidationRuleEditorModel';
import { guid } from 'rewire-common';

export class AddValidationRuleDialogModel extends Modal {
  validationRuleEditorModel: ValidationRuleEditorModel;
  form: Form;

  constructor(validationRuleEditorModel: ValidationRuleEditorModel) {
    super('Add Validation');

    this.validationRuleEditorModel = validationRuleEditorModel;
    this.form = Form.create((_form: IFormContext) => ({}));

    this.action('cancel').action('add Validation Rule', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    const fieldNames = this.form.fields.map((field: IEditorField) => field.name);
    this.form.removeFields(fieldNames);
    this.form.reset();
  }

  load() {
    this.reset();
    if (!this.validationRuleEditorModel.table) {
      return;
    }

    this.state.title = `Add ${this.validationRuleEditorModel.table!.name} Rule`;
    const ruleSchemaSearcher = arraySearch(
      this.validationRuleEditorModel.table.schema,
      (item?: IValidationRule) => item?.name ?? '',
    );

    this.form.addFields((_) => {
      const fields: IFieldDefns = {};
      fields['ruleSchema'] = _.reference(ruleSchemaSearcher).label('Validation Rule').validators('required');
      return fields;
    }, {});

    this.open();
  }

  private addRule = async (): Promise<boolean> => {
    if (!this.validationRuleEditorModel.table) {
      return false;
    }

    const ruleSchema = this.form.field.ruleSchema.value;

    const newValidationRule: IValidationRule = {
      id: guid(),
      schemaId: ruleSchema.schemaId,
      priority: ruleSchema.priority,
      parameters: ruleSchema.parameters && merge({}, ruleSchema.parameters),
      name: ruleSchema.name,
      category: ruleSchema.category,
      isNew: true,
    };

    this.validationRuleEditorModel.addRule(newValidationRule);
    return true;
  };

  submit = async () => {
    return await this.form.submitAsync(this.addRule);
  };
}

export default AddValidationRuleDialogModel;
